module.exports = __webpack_public_path__ + "img/DocmaLogoPNG.b3db854b.png";